import loadable from '@loadable/component';

export const ChatsContainerLoadable = loadable(() => import('./ChatsContainer'), { ssr: false });
ChatsContainerLoadable.displayName = 'ChatsContainerLoadable';
